export class Tab{
  type: string;
  data: string;
  header: string;
  visible:boolean = true;
}
